import { ApolloError } from '@apollo/client';

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableHeader,
  FilterButton,
  LinearProgress,
  DownloadIcon,
  CircularProgress,
  IPaginationProps,
  LoadedContent,
  Pagination,
} from '@occc/ui-design-system';

import { TobaccoWeeklySubmissionsTableRow } from './tobacco-weekly-submissions-table-row.component';

import { RetailerNetworkScanDataWeeklySubmission } from '../tobacco-submissions.types';

type TobaccoWeeklySubmissionsTableProps = {
  data?: RetailerNetworkScanDataWeeklySubmission[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  isFiltersSelected?: boolean;
  onViewAllStoresClick: (submission: RetailerNetworkScanDataWeeklySubmission) => void;
  onFilterClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isDownloading?: boolean;
  onDownloadReportClick: () => void;
};

export const TobaccoWeeklySubmissionsTable = ({
  data,
  loading,
  error,
  paginationProps,
  isFiltersSelected,
  onFilterClick,
  onViewAllStoresClick,
  isDownloading,
  onDownloadReportClick,
}: TobaccoWeeklySubmissionsTableProps) => {
  const renderData = (items: RetailerNetworkScanDataWeeklySubmission[]) => (
    <>
      {loading && <LinearProgress />}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Weekly Submission</TableCell>
            <TableCell>Submission Status</TableCell>
            <TableCell>Stores Submitted</TableCell>
            <TableCell align='right'>Estimated Reimbursement</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, index) => (
            <TobaccoWeeklySubmissionsTableRow
              key={index}
              item={item}
              onViewAllStoresClick={onViewAllStoresClick}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </>
  );

  return (
    <TableContainer>
      <TableHeader
        title={'Store Submission Status'}
        actions={
          <>
            <FilterButton
              showBadge={isFiltersSelected}
              onClick={onFilterClick}
              aria-label='filter submissions'
            />
            <Button
              variant='contained'
              color='secondary'
              onClick={onDownloadReportClick}
              disabled={isDownloading}
              startIcon={
                isDownloading ? <CircularProgress size={22} thickness={4} /> : <DownloadIcon />
              }
            >
              Download Report
            </Button>
          </>
        }
      />
      <LoadedContent error={error} loading={loading} items={data} renderData={renderData} />
    </TableContainer>
  );
};
